import React, { useCallback, useEffect, useRef, useState } from 'react';
import Button from '../../components/Button/Button';
import Select from '../../components/Select/Select';
import getBitrixMarks from '../../api/cars/getBitrixMarks';
import checkBitrixMark from '../../api/cars/checkBitrixMark';
import startBitrixImport from '../../api/cars/startBitrixImport';
import getBitrixImportStatus from '../../api/cars/getBitrixImportStatus';
import alert from '../../helpers/alert';
import useOriginOptions from './useOriginOptions';
import styles from './bitrixImportPanel.module.css';

const POLL_INTERVAL_MS = 1500;

// ÐÐ¾Ð»Ñ, Ð¾ÑÑÑÑÑÑÐ²Ð¸Ðµ ÐºÐ¾ÑÐ¾ÑÑÑ ÑÑÐ¾Ð¸Ñ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ. ÐÐ´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾ÑÑ Ð½Ð°Ð¹Ð´ÐµÐ½Ð½ÑÑ Ð¿Ð¾Ð»ÐµÐ¹
// Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð½Ðµ Ð½ÑÐ¶Ð½Ñ â Ð¾Ð½Ð¸ Ð³Ð¾Ð²Ð¾ÑÑÑ ÑÑÐ¾-ÑÐ¾ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ°Ð·ÑÐ°Ð±Ð¾ÑÑÐ¸ÐºÑ
const IMPORTANT_FIELDS = {
  model: 'ÐÐ¾Ð´ÐµÐ»Ñ',
  complectation: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
  color: 'Ð¦Ð²ÐµÑ',
  year: 'ÐÐ¾Ð´ Ð²ÑÐ¿ÑÑÐºÐ°',
  transmission: 'Ð¢Ð¸Ð¿ ÐÐÐ',
  engineVolume: 'ÐÐ±ÑÑÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
  price: 'Ð¦ÐµÐ½Ð°',
};

const errorMessage = (err, fallback) =>
  err?.response?.data?.errorMessage || err?.response?.data?.message || fallback;

const oursUnmapped = (data) => (data.dcMap || []).filter((dc) => !dc.dcId && !dc.foreign);
const foreignUnmapped = (data) => (data.dcMap || []).filter((dc) => !dc.dcId && dc.foreign);
const mapped = (data) => (data.dcMap || []).filter((dc) => dc.dcId);

const missingFields = (data) =>
  Object.entries(IMPORTANT_FIELDS)
    .filter(([key]) => !(data.resolvedFields || {})[key])
    .map(([, label]) => label);

// ÐÐ½Ð´Ð¸ÐºÐ°ÑÐ¾Ñ Ð¾Ð¶Ð¸Ð´Ð°Ð½Ð¸Ñ. percent Ð·Ð°Ð´Ð°Ð½ â Ð¿Ð¾Ð»Ð¾ÑÐ° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ ÑÐµÐ°Ð»ÑÐ½ÑÐ¹ Ð¿ÑÐ¾Ð³ÑÐµÑÑ,
// Ð½Ðµ Ð·Ð°Ð´Ð°Ð½ â Ð±ÐµÐ¶Ð¸Ñ Ð±ÐµÑÐºÐ¾Ð½ÐµÑÐ½Ð¾: Ð²ÑÐ°ÑÑ Ð¿ÑÐ¾ÑÐµÐ½ÑÐ°Ð¼Ð¸ ÑÐ°Ð¼, Ð³Ð´Ðµ Ð¸Ñ Ð½ÐµÐ¾ÑÐºÑÐ´Ð° Ð²Ð·ÑÑÑ,
// ÑÑÐ¶Ðµ, ÑÐµÐ¼ ÑÐµÑÑÐ½Ð¾ Ð¿Ð¾ÐºÐ°Ð·Ð°ÑÑ Â«Ð¸Ð´ÑÑ ÑÐ°Ð±Ð¾ÑÐ°Â». Ð¡ÑÑÑÑÐ¸Ðº ÑÐµÐºÑÐ½Ð´ Ð¿Ð¾ÑÐ²Ð»ÑÐµÑÑÑ Ð½Ðµ ÑÑÐ°Ð·Ñ,
// ÑÑÐ¾Ð±Ñ Ð½Ðµ Ð¼Ð¸Ð³Ð°ÑÑ Ð½Ð° Ð±ÑÑÑÑÑÑ Ð¾ÑÐ²ÐµÑÐ°Ñ
const Waiting = ({ text, percent = null }) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.waiting}>
      <div className={styles.waitingBar}>
        <div
          className={percent === null ? styles.waitingFillRunning : styles.waitingFill}
          style={percent === null ? undefined : { width: `${percent}%` }}
        />
      </div>
      <div className={styles.waitingText}>
        {text}
        {seconds > 2 && <span className={styles.waitingSeconds}>{seconds} Ñ</span>}
      </div>
    </div>
  );
};

const DcTable = ({ rows }) => (
  <table className={styles.dcTable}>
    <thead>
      <tr>
        <th>ÐÑÐ´ÐµÐ» Ð² ÐÐ¸ÑÑÐ¸ÐºÑÐµ</th>
        <th>ÐÐ°ÑÐ¸Ð½</th>
        <th>ÐÐ°Ñ ÐÐ¦</th>
      </tr>
    </thead>
    <tbody>
      {rows.map((dc) => (
        <tr key={dc.departmentId} className={dc.dcId ? undefined : styles.dcRowUnmapped}>
          <td>
            <span className={styles.deptId}>{dc.departmentId}</span>
            {dc.departmentName || <i>Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð½Ðµ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¾</i>}
          </td>
          <td>{dc.deals}</td>
          <td>
            {dc.dcId ? (
              <>
                {dc.dcName}
                <span className={styles.dcCity}> Â· {dc.cityName}</span>
                {dc.manual && <span className={styles.dcManual}>Ð²ÑÑÑÐ½ÑÑ</span>}
              </>
            ) : dc.foreign ? (
              <span className={styles.warn}>ÑÑÐ¶Ð¾Ð¹ â Ð¿ÑÐ¾Ð¿ÑÑÐµÐ½</span>
            ) : (
              <span className={styles.warn}>Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ</span>
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

const BitrixImportPanel = ({ onResult }) => {
  const [marks, setMarks] = useState([]);
  const [loadingMarks, setLoadingMarks] = useState(true);
  const [selected, setSelected] = useState([]);
  // Ð ÐµÐ·ÑÐ»ÑÑÐ°Ñ Â«ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑÂ» Ð¿Ð¾ ÐºÐ°Ð¶Ð´Ð¾Ð¹ Ð¼Ð°ÑÐºÐµ: mark -> { loading, data, error }
  const [checks, setChecks] = useState({});
  const [expanded, setExpanded] = useState(null);
  const [origin, setOrigin] = useState(null);
  const [job, setJob] = useState(null);
  const pollRef = useRef(null);
  const originOptions = useOriginOptions();

  useEffect(() => {
    getBitrixMarks()
      .then((res) => setMarks(res?.data || []))
      .catch((err) => alert.error(errorMessage(err, 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¼Ð°ÑÐ¾Ðº')))
      .finally(() => setLoadingMarks(false));
  }, []);

  // ÐÐ¿ÑÐ¾Ñ ÑÑÐ°ÑÑÑÐ° Ð¶Ð¸Ð²ÑÑ ÑÐ¾Ð²Ð½Ð¾ ÑÑÐ¾Ð»ÑÐºÐ¾, ÑÐºÐ¾Ð»ÑÐºÐ¾ Ð¸Ð´ÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑ: Ð·Ð°Ð²Ð¾Ð´Ð¸ÑÑÑ Ð½Ð° ÑÑÐ°ÑÑÐµ Ð¸
  // Ð³Ð°ÑÐ¸ÑÑÑ Ð¸ Ð¿Ð¾ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¸Ñ, Ð¸ Ð¿ÑÐ¸ ÑÑÐ¾Ð´Ðµ ÑÐ¾ ÑÑÑÐ°Ð½Ð¸ÑÑ
  const stopPolling = useCallback(() => {
    if (pollRef.current) {
      clearInterval(pollRef.current);
      pollRef.current = null;
    }
  }, []);

  useEffect(() => stopPolling, [stopPolling]);

  const toggleMark = (mark) => {
    setSelected((prev) =>
      prev.includes(mark) ? prev.filter((m) => m !== mark) : [...prev, mark]
    );
  };

  const runCheck = async (mark) => {
    setChecks((prev) => ({ ...prev, [mark]: { loading: true } }));
    setExpanded(mark);
    try {
      const res = await checkBitrixMark(mark);
      setChecks((prev) => ({ ...prev, [mark]: { loading: false, data: res.data } }));
    } catch (err) {
      setChecks((prev) => ({
        ...prev,
        [mark]: { loading: false, error: errorMessage(err, 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð²ÑÐ¿Ð¾Ð»Ð½Ð¸ÑÑ Ð¿ÑÐ¾Ð²ÐµÑÐºÑ') },
      }));
    }
  };

  const handleStart = async () => {
    if (selected.length === 0) return;
    try {
      const res = await startBitrixImport(selected, origin?.label || null);
      const jobId = res?.data?.jobId;
      if (!jobId) throw new Error();

      setJob({ status: 'fetching', total: 0, processed: 0 });
      pollRef.current = setInterval(async () => {
        try {
          const status = await getBitrixImportStatus(jobId);
          const data = status.data;
          setJob(data);

          if (data.status === 'done') {
            stopPolling();
            // ÐÑÐµÐ´ÑÐ¿ÑÐµÐ¶Ð´ÐµÐ½Ð¸Ñ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð·Ð´ÐµÑÑ Ð¶Ðµ, ÑÑÐ´Ð¾Ð¼ Ñ Ð¼Ð°ÑÐºÐ°Ð¼Ð¸ â Ð½Ð°Ð²ÐµÑÑ Ð½Ðµ Ð¾ÑÐ´Ð°ÑÐ¼,
            // Ð¸Ð½Ð°ÑÐµ ÑÑÑÐ°Ð½Ð¸ÑÐ° Ð¾ÑÑÐ¸ÑÑÐµÑ Ð¸Ñ Ð²ÑÐ¾ÑÑÐ¼ ÑÐºÐ·ÐµÐ¼Ð¿Ð»ÑÑÐ¾Ð¼
            onResult(data.result);
            alert.success(`ÐÐ¼Ð¿Ð¾ÑÑ Ð·Ð°Ð²ÐµÑÑÑÐ½. ÐÐ°Ð³ÑÑÐ¶ÐµÐ½Ð¾ Ð¼Ð°ÑÐ¸Ð½: ${data.result?.imported ?? 0}`);
          }
          if (data.status === 'error') {
            stopPolling();
            alert.error(data.error || 'ÐÐ¼Ð¿Ð¾ÑÑ Ð·Ð°Ð²ÐµÑÑÐ¸Ð»ÑÑ Ð¾ÑÐ¸Ð±ÐºÐ¾Ð¹');
          }
        } catch (err) {
          stopPolling();
          setJob((prev) => ({ ...prev, status: 'error', error: errorMessage(err, 'Ð¡Ð²ÑÐ·Ñ Ñ Ð·Ð°Ð´Ð°ÑÐµÐ¹ Ð¸Ð¼Ð¿Ð¾ÑÑÐ° Ð¿Ð¾ÑÐµÑÑÐ½Ð°') }));
        }
      }, POLL_INTERVAL_MS);
    } catch (err) {
      alert.error(errorMessage(err, 'ÐÐµ ÑÐ´Ð°Ð»Ð¾ÑÑ Ð·Ð°Ð¿ÑÑÑÐ¸ÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑ'));
    }
  };

  const running = job?.status === 'fetching' || job?.status === 'importing';
  const percent = job?.total > 0 ? Math.round((100 * job.processed) / job.total) : 0;

  // ÐÑÐ¾Ð³Ð¸ Ð¿Ð¾ Ð¿ÑÐ¾Ð²ÐµÑÐµÐ½Ð½ÑÐ¼ Ð¼Ð°ÑÐºÐ°Ð¼ Ð¸Ð· ÑÐ¸ÑÐ»Ð° Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ. ÐÐ¾ÐºÐ° Ð¿ÑÐ¾Ð²ÐµÑÐµÐ½Ñ Ð½Ðµ Ð²ÑÐµ,
  // ÑÐ¸ÑÐ»Ð° Ð½Ðµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ â Ð²ÑÐ°ÑÑ Ð¾ ÐºÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ðµ ÑÑÐ¶Ðµ, ÑÐµÐ¼ Ð½Ðµ Ð½Ð°Ð·ÑÐ²Ð°ÑÑ ÐµÐ³Ð¾
  const checkedSelected = selected.map((m) => checks[m]?.data).filter(Boolean);
  const allChecked = checkedSelected.length === selected.length && selected.length > 0;
  const willImport = allChecked ? checkedSelected.reduce((sum, d) => sum + d.rows, 0) : null;
  const manualRows = checkedSelected.reduce((sum, d) => sum + (d.manualDc || 0), 0);
  const skippedRows = checkedSelected.reduce((sum, d) => sum + (d.skippedForeign || 0), 0);

  if (loadingMarks) {
    return <div className={styles.placeholder}>ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÐ¼ ÑÐ¿Ð¸ÑÐ¾Ðº Ð¼Ð°ÑÐ¾Ðºâ¦</div>;
  }

  if (marks.length === 0) {
    return (
      <div className={styles.placeholder}>
        <div className={styles.placeholderTitle}>ÐÐ¸ Ð¾Ð´Ð½Ð° Ð¼Ð°ÑÐºÐ° Ð½Ðµ Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð°</div>
        <p>
          ÐÐ¼Ð¿Ð¾ÑÑ Ð½Ð°ÑÑÑÐ°Ð¸Ð²Ð°ÐµÑÑÑ Ð½Ð° Ð±ÑÐºÐµÐ½Ð´Ðµ Ð² <code>appsettings.json</code>, ÐºÐ»ÑÑ{' '}
          <code>BITRIX_STOCK</code> â Ð¿Ð¾ Ð¾Ð´Ð½Ð¾Ð¹ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð½Ð° Ð¼Ð°ÑÐºÑ: Ð²ÐµÐ±ÑÑÐº Ð¿Ð¾ÑÑÐ°Ð»Ð° Ñ Ð¿ÑÐ°Ð²Ð°Ð¼Ð¸{' '}
          <code>crm</code> Ð¸ <code>department</code>, Ð¸Ð´ÐµÐ½ÑÐ¸ÑÐ¸ÐºÐ°ÑÐ¾Ñ Ð²Ð¾ÑÐ¾Ð½ÐºÐ¸ Ð¸ ÑÐ¿Ð¸ÑÐ¾Ðº ÑÑÐ°Ð´Ð¸Ð¹,
          Ð¼Ð°ÑÐ¸Ð½Ñ ÐºÐ¾ÑÐ¾ÑÑÑ Ð´Ð¾ÑÑÑÐ¿Ð½Ñ Ðº Ð¿ÑÐ¾Ð´Ð°Ð¶Ðµ.
        </p>
        <p className={styles.placeholderHint}>
          ÐÐ¾ÑÑÐ´Ð¾Ðº Ð¿Ð¾Ð´ÐºÐ»ÑÑÐµÐ½Ð¸Ñ Ð½Ð¾Ð²Ð¾Ð¹ Ð¼Ð°ÑÐºÐ¸ Ð¾Ð¿Ð¸ÑÐ°Ð½ Ð²{' '}
          <code>doscar_back/docs/bitrix-stock-import.md</code>
        </p>
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.markList}>
        {marks.map((m) => {
          const check = checks[m.mark];
          const isOpen = expanded === m.mark;
          return (
            <div key={m.mark} className={styles.markCard}>
              <div className={styles.markRow}>
                <label className={styles.markPick}>
                  <input
                    type="checkbox"
                    checked={selected.includes(m.mark)}
                    disabled={running || !m.knownMark}
                    onChange={() => toggleMark(m.mark)}
                  />
                  <span className={styles.markName}>{m.mark}</span>
                </label>

                <div className={styles.markMeta}>
                  {/* ÐÐ¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ Ð½Ðµ Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ¸, Ð° ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾, Ð½Ð° ÑÑÐ¾ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ Ð¼Ð¾Ð¶ÐµÑ
                      ÑÑÐµÐ°Ð³Ð¸ÑÐ¾Ð²Ð°ÑÑ: Ð±ÐµÐ· Ð±ÐµÐ»Ð¾Ð³Ð¾ ÑÐ¿Ð¸ÑÐºÐ° ÑÑÐ°Ð´Ð¸Ð¹ Ð² ÑÑÐ¾Ðº ÑÐµÐ´ÑÑ Ð¸ ÑÐµÐ·ÐµÑÐ²,
                      Ð¸ Ð´ÐµÑÐµÐºÑÐ½ÑÐµ Ð¼Ð°ÑÐ¸Ð½Ñ */}
                  {!m.stages?.length && (
                    <span className={styles.warn}>
                      Ð¡ÑÐ°Ð´Ð¸Ð¸ Ð½Ðµ Ð·Ð°Ð´Ð°Ð½Ñ: Ð±ÑÐ´ÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ Ð²ÑÐµ Ð½ÐµÐ·Ð°ÐºÑÑÑÑÐµ ÑÐ´ÐµÐ»ÐºÐ¸, Ð²ÐºÐ»ÑÑÐ°Ñ
                      Ð·Ð°ÑÐµÐ·ÐµÑÐ²Ð¸ÑÐ¾Ð²Ð°Ð½Ð½ÑÐµ Ð¸ Ð´ÐµÑÐµÐºÑÐ½ÑÐµ Ð¼Ð°ÑÐ¸Ð½Ñ
                    </span>
                  )}
                </div>

                <Button
                  text={check?.loading ? 'ÐÑÐ¾Ð²ÐµÑÑÐµÐ¼â¦' : 'ÐÑÐ¾Ð²ÐµÑÐ¸ÑÑ'}
                  onClick={() => runCheck(m.mark)}
                  disabled={running || check?.loading}
                />
              </div>

              {check?.loading && (
                <Waiting text="ÐÐ°Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÐ¼ Ð´Ð°Ð½Ð½ÑÐµ Ð¸Ð· ÐÐ¸ÑÑÐ¸ÐºÑÐ°: Ð¿Ð¾Ð»Ñ, ÑÐ´ÐµÐ»ÐºÐ¸, ÑÑÑÑÐºÑÑÑÑ ÐºÐ¾Ð¼Ð¿Ð°Ð½Ð¸Ð¸" />
              )}

              {!m.knownMark && (
                <div className={styles.markError}>
                  ÐÐ°ÑÐºÐ° Â«{m.mark}Â» Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ â Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ Ð½ÐµÑÐµÐ³Ð¾. ÐÐ¾Ð±Ð°Ð²ÑÑÐµ ÐµÑ Ð²
                  ÑÐ°Ð·Ð´ÐµÐ» Ð¼Ð°ÑÐ¾Ðº Ð¸Ð»Ð¸ Ð¸ÑÐ¿ÑÐ°Ð²ÑÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ.
                </div>
              )}

              {isOpen && check?.error && <div className={styles.markError}>{check.error}</div>}

              {isOpen && check?.data && (
                <div className={styles.checkResult}>
                  <div className={styles.checkStats}>
                    <span>
                      Ð¡Ð´ÐµÐ»Ð¾Ðº Ð² Ð²Ð¾ÑÐ¾Ð½ÐºÐµ: <b>{check.data.totalDeals}</b>
                    </span>
                    <span>
                      ÐÑÐ´ÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ: <b>{check.data.rows - (check.data.manualDc || 0)}</b>
                    </span>
                    {check.data.manualDc > 0 && (
                      <span className={styles.warn}>
                        ÑÑÐµÐ±ÑÑÑ ÑÑÑÐ½Ð¾Ð¹ Ð¿ÑÐ¸Ð²ÑÐ·ÐºÐ¸ ÐÐ¦: {check.data.manualDc}
                      </span>
                    )}
                    {check.data.skippedForeign > 0 && (
                      <span className={styles.warn}>
                        ÑÑÐ¶Ð¸Ðµ Ð´Ð¸Ð»ÐµÑÑ Ð¿ÑÐ¾Ð¿ÑÑÐµÐ½Ñ: {check.data.skippedForeign}
                      </span>
                    )}
                  </div>

                  {/* Ð Ð°Ð·Ð±Ð¸ÑÐ°ÑÑÑÑ Ð½ÑÐ¶Ð½Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ñ Ð½ÐµÑÐ¾Ð¿Ð¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð½ÑÐ¼Ð¸; ÑÑÐ¿ÐµÑÐ½ÑÐµ ÑÑÑÐ¾ÐºÐ¸
                      Ð¿Ð¾ÑÐ»Ðµ Ð¿ÐµÑÐ²Ð¾Ð¹ Ð¿ÑÐ¾Ð²ÐµÑÐºÐ¸ â ÑÑÐ¼, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾Ð½Ð¸ ÑÐ²ÑÑÐ½ÑÑÑ */}
                  {oursUnmapped(check.data).length > 0 && (
                    <>
                      <DcTable rows={oursUnmapped(check.data)} />
                      <div className={styles.hint}>
                        Ð­ÑÐ¸ Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ðµ ÑÐµÐ½ÑÑÑ Ð¿Ð¾ÑÐ¾Ð¶Ð¸ Ð½Ð° Ð½Ð°ÑÐ¸, Ð½Ð¾ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ Ð½ÐµÑ Ð¾Ð´Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð¾Ð¹
                        Ð·Ð°Ð¿Ð¸ÑÐ¸. ÐÐ°ÑÐ¸Ð½Ñ Ð±ÑÐ´ÑÑ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°Ð½Ñ, ÑÐµÐ½ÑÑ Ñ ÐºÐ°Ð¶Ð´Ð¾Ð¹ Ð¿Ð¾ÑÑÐµÐ±ÑÐµÑÑÑ ÑÐºÐ°Ð·Ð°ÑÑ
                        Ð²ÑÑÑÐ½ÑÑ. Ð§ÑÐ¾Ð±Ñ ÑÑÐ¾ Ð½Ðµ Ð¿Ð¾Ð²ÑÐ¾ÑÑÐ»Ð¾ÑÑ, Ð´Ð¾Ð±Ð°Ð²ÑÑÐµ ÑÐµÐ½ÑÑ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸Ðº Ð¸Ð»Ð¸
                        ÑÐ²ÑÐ¶Ð¸ÑÐµ Ð¾ÑÐ´ÐµÐ» Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ.
                        <details className={styles.spoiler}>
                          <summary>ÐÐ°Ðº ÑÐ²ÑÐ·Ð°ÑÑ Ð² Ð½Ð°ÑÑÑÐ¾Ð¹ÐºÐ°Ñ</summary>
                          Ð <code>BITRIX_STOCK</code> ÑÑÐ¾Ð¹ Ð¼Ð°ÑÐºÐ¸:{' '}
                          <code>{'"dcMap": { "<id Ð¾ÑÐ´ÐµÐ»Ð°>": <id Ð½Ð°ÑÐµÐ³Ð¾ ÐÐ¦> }'}</code>
                        </details>
                      </div>
                    </>
                  )}

                  {foreignUnmapped(check.data).length > 0 && (
                    <details className={styles.mappedBlock}>
                      <summary>
                        Ð§ÑÐ¶Ð¸Ðµ Ð´Ð¸Ð»ÐµÑÑ Ð¿Ð¾ÑÑÐ°Ð»Ð°, Ð½Ðµ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÑÑÑÑÑ:{' '}
                        {foreignUnmapped(check.data).length}
                      </summary>
                      <DcTable rows={foreignUnmapped(check.data)} />
                    </details>
                  )}

                  {mapped(check.data).length > 0 && (
                    <details className={styles.mappedBlock}>
                      <summary>ÐÐ°Ð¹Ð´ÐµÐ½Ñ Ð² ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐµ: {mapped(check.data).length}</summary>
                      <DcTable rows={mapped(check.data)} />
                    </details>
                  )}

                  {missingFields(check.data).length > 0 && (
                    <div className={styles.markError}>
                      ÐÐ° Ð¿Ð¾ÑÑÐ°Ð»Ðµ Ð½Ðµ Ð½Ð°Ð¹Ð´ÐµÐ½Ñ Ð¿Ð¾Ð»Ñ: {missingFields(check.data).join(', ')}. Ð­ÑÐ¸
                      Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð¾ÑÑÐ°Ð½ÑÑÑÑ Ð¿ÑÑÑÑÐ¼Ð¸.
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className={styles.originBlock}>
        <Select
          title="ÐÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»ÐµÐ¹"
          placeholder="ÐÐµ Ð²ÑÐ±ÑÐ°Ð½Ð¾ â Ð¿Ð¾ÑÑÐµÐ±ÑÐµÑÑÑ ÑÐºÐ°Ð·Ð°ÑÑ Ð²ÑÑÑÐ½ÑÑ"
          options={originOptions}
          value={origin}
          onChange={setOrigin}
          disabled={running}
        />
        <div className={styles.hint}>
          Ð ÐÐ¸ÑÑÐ¸ÐºÑÐµ ÑÑÐ¾ Ð¿Ð¾Ð»Ðµ Ð¾ÑÑÑÑÑÑÐ²ÑÐµÑ. ÐÑÐ±ÑÐ°Ð½Ð½Ð¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð±ÑÐ´ÐµÑ Ð¿ÑÐ¾ÑÑÐ°Ð²Ð»ÐµÐ½Ð¾ Ð²ÑÐµÐ¼
          Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÑÐµÐ¼ÑÐ¼ Ð¼Ð°ÑÐ¸Ð½Ð°Ð¼.
        </div>
      </div>

      {selected.length > 0 && !running && (
        <div className={styles.replaceNotice}>
          ÐÐ¼Ð¿Ð¾ÑÑ Ð·Ð°Ð¼ÐµÐ½Ð¸Ñ ÑÑÐ¾Ðº Ð²ÑÐ±ÑÐ°Ð½Ð½ÑÑ Ð¼Ð°ÑÐ¾Ðº: Ð¼Ð°ÑÐ¸Ð½Ñ, Ð¾ÑÑÑÑÑÑÐ²ÑÑÑÐ¸Ðµ Ð² Ð²ÑÐ³ÑÑÐ·ÐºÐµ, Ð±ÑÐ´ÑÑ ÑÐ½ÑÑÑ
          Ñ Ð²Ð¸ÑÑÐ¸Ð½Ñ. ÐÐ¸Ð»ÐµÑÑÐºÐ¸Ðµ ÑÐµÐ½ÑÑÑ Ð±ÐµÐ· Ð¿Ð¾ÑÑÑÐ¿Ð»ÐµÐ½Ð¸Ð¹ Ð½Ðµ Ð·Ð°ÑÑÐ°Ð³Ð¸Ð²Ð°ÑÑÑÑ.
          {manualRows > 0 &&
            ` Ð£ ${manualRows} Ð¼Ð°ÑÐ¸Ð½ Ð½Ðµ Ð¾Ð¿ÑÐµÐ´ÐµÐ»ÑÐ½ Ð´Ð¸Ð»ÐµÑÑÐºÐ¸Ð¹ ÑÐµÐ½ÑÑ â Ð¸Ñ Ð¿Ð¾ÑÑÐµÐ±ÑÐµÑÑÑ Ð¸ÑÐ¿ÑÐ°Ð²Ð¸ÑÑ Ð²ÑÑÑÐ½ÑÑ.`}
          {skippedRows > 0 && ` Ð§ÑÐ¶Ð¸Ðµ Ð´Ð¸Ð»ÐµÑÑ (${skippedRows} Ð¼Ð°ÑÐ¸Ð½) Ð½Ðµ Ð¸Ð¼Ð¿Ð¾ÑÑÐ¸ÑÑÑÑÑÑ.`}
        </div>
      )}

      <div className={styles.actions}>
        <Button
          fill
          text={willImport !== null ? `ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ (${willImport})` : 'ÐÐ¼Ð¿Ð¾ÑÑÐ¸ÑÐ¾Ð²Ð°ÑÑ'}
          onClick={handleStart}
          disabled={running || selected.length === 0}
        />
      </div>

      {job && running && (
        <div className={styles.progress}>
          {job.status === 'fetching' ? (
            <>
              <Waiting
                text={
                  `ÐÐ°Ð³ÑÑÐ¶Ð°ÐµÐ¼ ÑÐ´ÐµÐ»ÐºÐ¸ Ð¸Ð· ÐÐ¸ÑÑÐ¸ÐºÑÐ°${job.currentMark ? ` Â· ${job.currentMark}` : ''}` +
                  (job.total > 0 ? ` â ${job.processed} Ð¸Ð· ${job.total}` : '')
                }
                percent={job.total > 0 ? percent : null}
              />
              <div className={styles.hint}>
                Ð¡ÑÐ¾Ðº Ð½Ðµ Ð¸Ð·Ð¼ÐµÐ½ÑÐµÑÑÑ Ð´Ð¾ Ð·Ð°Ð²ÐµÑÑÐµÐ½Ð¸Ñ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸
              </div>
            </>
          ) : (
            // ÐÐ¼Ð¿Ð¾ÑÑÑÑ Ð¾ÑÐ´Ð°ÑÑ ÑÐµÐ·ÑÐ»ÑÑÐ°Ñ ÑÐµÐ»Ð¸ÐºÐ¾Ð¼, Ð¿Ð¾ÑÑÑÐ¾ÑÐ½Ð¾Ð³Ð¾ Ð¿ÑÐ¾Ð³ÑÐµÑÑÐ° Ñ Ð½ÐµÐ³Ð¾ Ð½ÐµÑ â
            // Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¿Ð¾Ð»Ð¾ÑÐ° Ð±ÐµÐ¶Ð¸Ñ, Ð° Ð½Ðµ Ð·Ð°Ð¼Ð¸ÑÐ°ÐµÑ Ð½Ð° ÑÑÐ° Ð¿ÑÐ¾ÑÐµÐ½ÑÐ°Ñ
            <Waiting
              text={
                willImport !== null
                  ? `Ð¡Ð¾ÑÑÐ°Ð½ÑÐµÐ¼ Ð² ÑÑÐ¾Ðº: ${willImport} Ð¼Ð°ÑÐ¸Ð½`
                  : 'Ð¡Ð¾ÑÑÐ°Ð½ÑÐµÐ¼ Ð² ÑÑÐ¾Ðº'
              }
            />
          )}
        </div>
      )}

      {job?.status === 'error' && <div className={styles.markError}>{job.error}</div>}

      {job?.warnings?.length > 0 && job.status === 'done' && (
        <div className={styles.warnings}>
          {job.warnings.map((w, i) => (
            <div key={i}>{w}</div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BitrixImportPanel;
